import Cookies from "js-cookie";

export type ConsentValue = "necessary" | "accepted";

const COOKIE_NAME = "cookie_consent";
const LOGIN_COOKIE_NAME = "islogin";
const COOKIE_DOMAIN = ".s10.run";
const CONSENT_VERSION = "6.0";
const COOKIE_MAX_AGE_DAYS = 365;

export function isLoggedInByCookie() {
  return Cookies.get(LOGIN_COOKIE_NAME) === "1";
}

export function readConsent(): ConsentValue | null {
  const value = Cookies.get(COOKIE_NAME);

  if (!value) {
    return null;
  }

  const [consentValue, consentVersion] = value.split(":");

  if (consentVersion !== CONSENT_VERSION) {
    return null;
  }

  if (consentValue === "necessary" || consentValue === "accepted") {
    return consentValue;
  }

  return null;
}

export function saveConsent(value: ConsentValue) {
  const isLocalhost =
    location.hostname === "localhost" || location.hostname === "127.0.0.1";

  Cookies.set(COOKIE_NAME, `${value}:${CONSENT_VERSION}`, {
    expires: COOKIE_MAX_AGE_DAYS,
    path: "/",
    domain: isLocalhost ? undefined : COOKIE_DOMAIN,
    sameSite: "lax",
    secure: location.protocol === "https:",
  });
}
